<!-- display-desktop-01 preview — Google video partners in-stream ad -->
<app-desktop-frame>
  <!-- START: Publisher page -->
  <div class="gvd-page">
    <!-- The mock names the partner site rather than drawing one: the ad is the
         subject, and the placement runs on any of them. -->
    <div class="gvd-masthead d-flex align-items-center justify-content-center">
      - Website -
    </div>

    <div class="gvd-body d-flex flex-row">
      <!-- START: Player running the ad -->
      <div class="gvd-column d-flex flex-column">
        <div class="gvd-player">
          <img
            *ngIf="thumbnailUrl; else noCreative"
            class="gvd-creative"
            [src]="thumbnailUrl"
            alt=""
          />

          <ng-template #noCreative>
            <div class="gvd-creative creative-missing">
              <ng-container *ngIf="isResolving; else askForVideo">
                Reading video formats&hellip;
              </ng-container>
              <ng-template #askForVideo>
                Add a {{ format }} video to see this preview
              </ng-template>
            </div>
          </ng-template>

          <!-- Ad chrome, only drawn over a creative — it is unreadable on the
               grey empty slot. -->
          <ng-container *ngIf="thumbnailUrl">
            <!-- The companion card: the only part of the player the author
                 writes. It is the CTA that carries the link, so the player
                 itself is not an anchor. -->
            <div class="gvd-card d-flex flex-row align-items-center">
              <img
                class="gvd-logo"
                src="assets/images/google-campaign-logos/collection/valamar-collection-512x512-color.png"
                alt=""
              />

              <div class="gvd-card-text d-flex flex-column">
                <span class="gvd-headline">{{ headline }}</span>
                <span class="gvd-url">{{ displayUrl }}</span>
              </div>

              <a
                [href]="data.url"
                target="_blank"
                rel="noopener noreferrer"
                class="gvd-cta"
                >{{ data.ctaText || "Your call to action" }}</a
              >
            </div>

            <span class="gvd-skip">Skip Ad <i class="bi bi-skip-end-fill"></i></span>
            <span class="gvd-countdown">00:08</span>
          </ng-container>
        </div>

        <!-- A yellow bar is what marks the player as running an ad. -->
        <div class="gvd-progress"><span class="gvd-progress-fill"></span></div>

        <div class="gvd-controls d-flex align-items-center">
          <i class="bi bi-pause-fill"></i>
        </div>
      </div>
      <!-- END: Player -->

      <!-- The publisher's article column beside the player, stubbed out -->
      <div class="gvd-rail d-flex flex-column">
        <span class="gvd-block placeholder"></span>
        <span
          *ngFor="let line of railLines; last as isLast"
          class="gvd-bar placeholder"
          [class.gvd-bar-short]="isLast"
        ></span>
      </div>
    </div>
  </div>
  <!-- END: Publisher page -->
</app-desktop-frame>
